// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AgreementDetails_wrapper__b7_Hs","actions":"AgreementDetails_actions__vIPpC","textWrapper":"AgreementDetails_textWrapper__e15q0"};